export class HeaderMenuModel {
    label!: string;
    links: HeaderLinkModel[]=[];
    Show!: boolean;
    Order!:number;
}

export class HeaderLinkModel {
    label!: string;
    action!: string; 
}

export const commonHeaderData: HeaderMenuModel[] = [
    // {
    //   label: "Home",
    //   links: [{ label: "Home", action: "/home" }],
    //   Show: true,
    //   Order: 1,
    // },
    // {
    //   label: "About Us",
    //   links: [{ label: "About Us", action: "/aboutus" }],
    //   Show: true,
    //   Order: 4,
    // },
    // {
    //   label: "Contact Us",
    //   links: [{ label: "Contact Us", action: "/contactus" }],
    //   Show: true,
    //   Order: 5,
    // },
    {
      label: "Register",
      links: [{ label: "Register", action: "/supplier/register" }],
      Show: true,
      Order: 5,
    }
  ];

  export const headerData: HeaderMenuModel[] = [
    ...commonHeaderData,
    {
      label: "Login",
      links: [
        { label: "Supplier", action: "Supplier" },
        { label: "Admin", action: "Admin" },
      ],
      Show: true,
      Order: 6,
    },
  ];

